var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud Saved",
    clipPath: "url(#clip0_288_24354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16658 15.834H5.58325C2.91658 15.834 0.833252 13.7507 0.833252 11.2507C0.833252 8.91738 2.58325 7.00071 4.91659 6.75071C5.49992 5.25071 6.74992 4.08404 8.33325 3.58404C10.1666 3.00071 12.1666 3.41738 13.6666 4.58404C14.8333 5.58404 15.5833 6.91738 15.5833 8.41738C16.9999 8.41738 18.2499 9.25071 18.8333 10.584C18.9999 11.0007 18.8333 11.5007 18.4166 11.6674C17.9999 11.834 17.4999 11.6674 17.3333 11.2507C16.9999 10.5007 16.2499 10.084 15.4999 10.084H14.6666C14.4166 10.084 14.1666 10.0007 13.9999 9.75071C13.8333 9.58404 13.7499 9.33404 13.8333 9.08404C14.0833 7.83404 13.5833 6.66738 12.6666 5.83404C11.6666 5.00071 10.1666 4.75071 8.91658 5.16738C7.66658 5.58404 6.66658 6.50071 6.41658 7.66738C6.24992 8.08404 5.91658 8.33404 5.58325 8.33404C3.91658 8.33404 2.49992 9.66738 2.49992 11.2507C2.49992 12.834 3.83325 14.1674 5.58325 14.1674H9.16658C9.66658 14.1674 9.99992 14.5007 9.99992 15.0007C9.99992 15.5007 9.66658 15.834 9.16658 15.834Z",
    fill: "#454551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1667 18.334C13.9167 18.334 13.7501 18.2507 13.5834 18.084L11.9167 16.4173C11.5834 16.084 11.5834 15.584 11.9167 15.2507C12.2501 14.9173 12.7501 14.9173 13.0834 15.2507L14.1667 16.334L16.9167 13.584C17.2501 13.2507 17.7501 13.2507 18.0834 13.584C18.4167 13.9173 18.4167 14.4173 18.0834 14.7507L14.7501 18.084C14.5834 18.2507 14.4167 18.334 14.1667 18.334Z",
    fill: "#454551"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_24354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSaved);
export default __webpack_public_path__ + "static/media/cloud-saved.9415082e7fce84bc0107dd8e6f3a4aff.svg";
export { ForwardRef as ReactComponent };